<template>
  <b-modal
    v-if="!this.$lodash.isEmpty(templateMessagep)"
    id="template-message-delete-modal"
    ref="templateMessageDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete {{ getLanguageName(templateMessagep.language) }} Template Message for {{ templateMessagep.keyword }}?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import getLanguageName from '@/helpers/getLanguageName';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TemplateMessageDeleteModal',
  props: {
    templateMessagep: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      templateMessageDeleted: 'notification/templateMessageDeleted',
      apiError: 'notification/apiError',
    }),
  },
  watch: {
    templateMessageDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteTemplateMessage: 'notification/deleteTemplateMessage',
    }),
    getLanguageName,
    commitDelete() {
      this.deleting = true;
      this.deleteTemplateMessage({
        merchant_id: this.$route.params.merchant_id,
        template_message_id: this.templateMessagep.id,
      });
    },
    show() {
      this.$refs.templateMessageDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.templateMessageDeleteModal.hide();
    },
  },
};
</script>
